module.exports = __webpack_public_path__ + "/login_ui/img/ch-6cc6aeb1e6184360796117b4600b5448.svg";